module.exports = __webpack_public_path__ + "img/oliver-borner14.a165609f.jpg";